import { IPoint } from '../helpers/types';

const square = (x: number) => x * x;

export function getParellelPoints(
  ax: number,
  ay: number,
  bx: number,
  by: number,
  l: number
) {
  console.log('parellel debug', {
    ax,
    ay,
    bx,
    by,
    l,
  });
  const alpha = ax * bx + ay * by - square(bx) - square(by);
  const m = alpha / (ay - by);
  const n = (ax - bx) / (ay - by);
  const b = -2 * (bx + m * n - n * by);
  const c = square(m) - 2 * m * by - square(l) + square(bx) + square(by);
  const a = square(1 + n);
  const cx1 = (-1 * b + Math.sqrt(square(b) - 4 * a * c)) / (2 * a);
  const cx2 = (-1 * b - Math.sqrt(square(b) - 4 * a * c)) / (2 * a);
  const cy1 = (alpha - cx1 * (ax - bx)) / (ay - by);
  const cy2 = (alpha - cx2 * (ax - bx)) / (ay - by);
  console.log('parellel debug 2', {
    calLen: Math.sqrt(square(cx1 - bx) + square(cy1 - by)),
  });
  return {
    point1: {
      x: cx1,
      y: cy1,
    },
    point2: {
      x: cx2,
      y: cy2,
    },
  };
}

export function getPointAtDistance(
  x0: number,
  y0: number,
  x1: number,
  y1: number,
  dist: number // distance from x0, y0, away from x0, y0
) {
  const d = Math.sqrt(square(x1 - x0) + square(y1 - y0));
  const t = dist / d;
  return {
    x: (1 - t) * x0 + t * x1,
    y: (1 - t) * y0 + t * y1,
  };
}

export function getParellelPoints2(
  ax: number,
  ay: number,
  bx: number,
  by: number,
  l: number
) {
  const l1 = l;
  const lineSegmentLength = Math.sqrt(square(bx - ax) + square(by - ay));
  const hypotenuse = Math.sqrt(square(l1) + square(lineSegmentLength));
  const angle = (Math.asin(l1 / hypotenuse) * 180) / Math.PI;

  return {
    point1: {
      ...rotate(
        { x: bx, y: by },
        getPointAtDistance(bx, by, ax, ay, hypotenuse),
        -1 * angle
      ),
    },
    point2: {
      ...rotate(
        { x: ax, y: ay },
        getPointAtDistance(ax, ay, bx, by, hypotenuse),
        angle
      ),
    },
    point3: {
      ...rotate(
        { x: bx, y: by },
        getPointAtDistance(bx, by, ax, ay, hypotenuse),
        angle
      ),
    },
    point4: {
      ...rotate(
        { x: ax, y: ay },
        getPointAtDistance(ax, ay, bx, by, hypotenuse),
        -1 * angle
      ),
    },
  };
}

export const nauticalMileToMeter = (x: number) => x * 1852;

const rotate = (center: any, current: any, angle: any) => {
  const radians = (Math.PI / 180) * angle;
  const cos = Math.cos(radians);
  const sin = Math.sin(radians);
  const x =
    cos * (current.x - center.x) + sin * (current.y - center.y) + center.x;
  const y =
    cos * (current.y - center.y) - sin * (current.x - center.x) + center.y;
  return { x, y };
};

export const getIntersectionPoint = (
  x1: number,
  y1: number,
  x2: number,
  y2: number,
  x3: number,
  y3: number,
  x4: number,
  y4: number
) => {
  const d = (x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4);
  const px =
    ((x1 * y2 - y1 * x2) * (x3 - x4) - (x1 - x2) * (x3 * y4 - y3 * x4)) / d;
  const py =
    ((x1 * y2 - y1 * x2) * (y3 - y4) - (y1 - y2) * (x3 * y4 - y3 * x4)) / d;
  return {
    x: px,
    y: py,
  };
};

const lengthOfLine = (startPos: any, endPosition: any) => {
  return Math.sqrt(
    Math.pow(startPos.x - endPosition.x, 2) +
      Math.pow(startPos.y - endPosition.y, 2)
  );
};

export const getArrowPoints = (startPos: any, endPos: any) => {
  const midPoint = {
    x: (startPos.x + endPos.x) / 2,
    y: (startPos.y + endPos.y) / 2,
  };
  const length = lengthOfLine(startPos, midPoint);
  const ratio = (length - 15) / length;
  const x = (1 - ratio) * startPos.x + ratio * midPoint.x;
  const y = (1 - ratio) * startPos.y + ratio * midPoint.y;

  return {
    midPoint,
    endPoint: {
      x,
      y,
    },
  };
};

export const generateEndArrow = (startPos: any, endPos: any) => {
  const p1 = rotate(startPos, endPos, 30);
  const p2 = rotate(startPos, endPos, -30);
  return `M ${startPos.x} ${startPos.y} L ${p1.x} ${p1.y} M ${startPos.x} ${startPos.y}  L ${p2.x} ${p2.y}`;
};

/**
 * Converts an angle in degrees to its corresponding angle in radians
 * and adjust its orientation to point north.
 * @param angle - The angle in degrees.
 * @returns The angle in radians.
 */
export const convertToNorthAngleInRadians = (angle: number) =>
  (((-1 * angle + 180) % 360) * Math.PI) / 180;

export const calculateTriangleArea = (v1: IPoint, v2: IPoint, v3: IPoint) =>
  Math.abs(v1.x * (v2.y - v3.y) + v2.x * (v3.y - v1.y) + v3.x * (v1.y - v2.y)) /
  2;

//r1, r2, r3, r4 corners of the rectangle, point is to determine whether it's inside or outside.
// calculating the area of triangles
//formed from the corner points and given point of rectangle to determine
//whether the point is inside or outside of the rectangle

export const isPointInsideRectangle = (
  r1: IPoint,
  r2: IPoint,
  r3: IPoint,
  r4: IPoint,
  point: IPoint
) => {
  const pr1r2 = calculateTriangleArea(r1, r2, point);
  const pr2r3 = calculateTriangleArea(r2, r3, point);
  const pr3r4 = calculateTriangleArea(r3, r4, point);
  const pr4r1 = calculateTriangleArea(r4, r1, point);

  const rectAngleArea =
    calculateTriangleArea(r1, r2, r3) + calculateTriangleArea(r1, r4, r3);

  return rectAngleArea === pr1r2 + pr2r3 + pr3r4 + pr4r1;
};
